// Polyfills for SSR

var isSSR = typeof window === 'undefined';

export var HTMLElement = isSSR ? Object : window.HTMLElement;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/ssr.js
// module id = 1005
// module chunks = 0